// Adapted from https://gist.github.com/JonCatmull/da9c8bb7367f1f55a4080bbc525c09ac

import { Pipe, PipeTransform } from '@angular/core';

const ordinals: string[] = ['th', 'st', 'nd', 'rd'];

@Pipe({
  name: 'ordinal',
})
export class OrdinalPipe implements PipeTransform {
  public transform(n: number, keepNumber: boolean = false) {
    const v = n % 100;
    return (keepNumber ? n : '') + (ordinals[(v - 20) % 10] || ordinals[v] || ordinals[0]);
  }
}
